class RangeManager {
    initialValue = null;

    constructor(initialValue) {
        this.initialValue = initialValue;
    }

    to(referenceValue) {
        if (referenceValue > this.initialValue) {
            return this.plus(referenceValue - this.initialValue);
        }
        return this.plus(this.initialValue - referenceValue);
    }

    plus(value) {
        return [...Array(value + 1).keys()].map(i => this.initialValue + i);
    }

    minus(value) {
        return [...Array(value + 1).keys()].map(i => this.initialValue - i);
    }
}
export default function range(initialValue) {
    return new RangeManager(initialValue);
}
